
import React from 'react';
import sortIcon from '../assets/images/sort_icon.svg';

const CommanTable = ({ columns, data, actions, onSort, sortBy, onRowClick }) => {
  console.log("sortBy", sortBy);
  console.log("columns", columns);
  return (
    <table className="table table-striped">
      <thead>
        <tr>
          {columns.map((col, idx) => (
            <th key={col.key || idx} style={{ userSelect: 'none' }}>
              {col.sortable ? (
                <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, cursor: 'pointer' }} onClick={() => onSort && onSort(col.key)}>
                  {/* <img
                    src={sortIcon}
                    alt="sort"
                    className="dashboard-table-sort-icon"
                    style={sortBy === col.key ? { filter: "brightness(0) saturate(100%) invert(60%) sepia(28%) saturate(785%) hue-rotate(54deg) brightness(94%) contrast(83%)" } : {}}
                  /> */}
                  <img
                    src={sortIcon}
                    alt="sort"
                    className="dashboard-table-sort-icon"
                    style={
                      (sortBy === col.key || (sortBy === "firstname" && col.key === "name"))
                        ? { filter: "brightness(0) saturate(100%) invert(60%) sepia(28%) saturate(785%) hue-rotate(54deg) brightness(94%) contrast(83%)" }
                        : {}
                    }
                  />

                  {col.label}
                </span>
              ) : col.label}
            </th>
          ))}
          {actions && <th>{""}</th>}
        </tr>
      </thead>
      <tbody>
        {data.map((row, rowIdx) => (
          <tr
            key={row.id || rowIdx}
            style={{ cursor: onRowClick ? 'pointer' : undefined }}
            onClick={onRowClick ? () => onRowClick(row) : undefined}
          >
            {columns.map((col, colIdx) => (
              <td key={col.key || colIdx} className={col.key}>{row[col.key]}</td>
            ))}
            {actions && (
              <td>{actions(row)}</td>
            )}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default CommanTable;
